import { cn } from "@/lib/utils";
import { useCallback, useEffect, useRef, useState } from "react";

const NAV_ITEMS = [
  { id: "sec-outcome", label: "Current Outcome Period" },
  { id: "sec-op-perf", label: "Outcome Period Performance" },
  { id: "sec-performance", label: "Performance" },
  { id: "sec-premium", label: "Premium / Discount" },
  { id: "sec-scenarios", label: "Hypothetical Outcome Profile" },
  { id: "sec-holdings", label: "Holdings" },
  { id: "sec-fund-facts", label: "Fund Facts" },
  { id: "sec-documents", label: "Documents" },
] as const;

export function BufferSectionNav() {
  const [active, setActive] = useState<(typeof NAV_ITEMS)[number]["id"]>(NAV_ITEMS[0].id);
  const isClickScrolling = useRef<boolean>(false);

  useEffect(() => {
    const handleScroll = () => {
      if (isClickScrolling.current) return;
      for (let i = NAV_ITEMS.length - 1; i >= 0; i--) {
        const item = NAV_ITEMS[i]!;
        const el = document.getElementById(item.id);
        if (el && !el.closest('[class*="sidebar"]') && el.getBoundingClientRect().top <= 120) {
          setActive(item.id);
          return;
        }
      }
      setActive(NAV_ITEMS[0].id);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = useCallback((id: string) => {
    const el = document.getElementById(id);
    if (!el) return;
    const navH = 57;
    const snavH = 49;
    const top = el.getBoundingClientRect().top + window.scrollY - navH - snavH - 20;
    window.scrollTo({ top, behavior: "smooth" });
    setActive(id as (typeof NAV_ITEMS)[number]["id"]);
    isClickScrolling.current = true;
    setTimeout(() => {
      isClickScrolling.current = false;
    }, 800);
  }, []);

  return (
    <nav className="sticky top-[56px] z-[100] bg-[var(--etf-black)] border-b border-[var(--etf-border)] flex flex-nowrap px-10 gap-0 overflow-x-auto max-md:px-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      {NAV_ITEMS.map((item) => (
        <button
          type="button"
          key={item.id}
          className={cn(
            "flex-shrink-0 font-[family-name:var(--font-instrument)] text-[14px] tracking-[0.06em] text-[var(--etf-white3)] py-4 mr-10 border-b-2 border-transparent cursor-pointer whitespace-nowrap transition-all duration-150 bg-transparent border-t-0 border-l-0 border-r-0",
            "hover:text-[var(--etf-white2)]",
            "max-md:mr-5 max-md:text-[13px]",
            active === item.id && "text-[var(--etf-white)] border-b-[var(--etf-orange)]",
          )}
          onClick={() => scrollTo(item.id)}
        >
          {item.label}
        </button>
      ))}
    </nav>
  );
}
